'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tooltip", "tooltipOpen"];
import { BATTLESHIP, CALYPSO, CALYPSO_LIGHT, CALYPSO_MEDIUM, OLAF, SORBET_DARK } from 'HubStyleTokens/colors';
import { BUTTON_RADIUS } from 'HubStyleTokens/sizes';
import styled, { css } from 'styled-components';
import UITooltip from '../../tooltip/UITooltip';
import { FONT_FAMILIES } from '../../utils/Styles';
import { jsx as _jsx } from "react/jsx-runtime";
const todayDotMixin = css(["::before{content:' ';display:inline-block;position:absolute;border:2.5px solid currentColor;border-radius:50%;top:22px;left:16px;}"]);
const disabledMixin = css(["::after{content:' ';display:inline-block;position:absolute;top:12px;bottom:0;left:2px;right:13px;border-top:1px solid currentColor;transform:rotate(45deg);}"]);
const Cell = styled.td.withConfig({
  displayName: "Day__Cell",
  componentId: "wf34hu-0"
})(["position:relative;height:30px;padding:0;cursor:", ";color:", ";background-color:", ";border-radius:", ";", ";", ";", ";&:hover{background-color:", ";}"], ({
  isDisabled
}) => isDisabled ? 'not-allowed' : 'pointer', ({
  isDisabled,
  isSelected,
  isToday,
  isCurrentMonth
}) => {
  if (isDisabled) return BATTLESHIP;
  if (isSelected) return OLAF;
  if (!isCurrentMonth) return BATTLESHIP;
  if (isToday) return SORBET_DARK;
  return null;
}, ({
  isDisabled,
  isInRange,
  isSelected
}) => {
  if (isDisabled) return null;
  if (isSelected) return CALYPSO;
  if (isInRange) return CALYPSO_LIGHT;
  return null;
}, ({
  isInRange,
  isRangeStart,
  isRangeEnd
}) => {
  if (isInRange) return null;
  if (isRangeStart && isRangeEnd) return BUTTON_RADIUS;
  if (isRangeStart) return `${BUTTON_RADIUS} 0 0 ${BUTTON_RADIUS}`;
  if (isRangeEnd) return `0 ${BUTTON_RADIUS} ${BUTTON_RADIUS} 0`;
  return BUTTON_RADIUS;
}, ({
  isSelected,
  isToday
}) => isSelected || isToday ? FONT_FAMILIES.demibold : FONT_FAMILIES.medium, ({
  isToday
}) => isToday && todayDotMixin, ({
  isDisabled
}) => isDisabled && disabledMixin, ({
  isDisabled,
  isInRange,
  isSelected
}) => !isDisabled && !isSelected && (isInRange ? CALYPSO_MEDIUM : CALYPSO_LIGHT));
export default function Day(props) {
  const {
      tooltip,
      tooltipOpen
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UITooltip, {
    "aria-live": "polite",
    open: tooltipOpen,
    title: tooltip,
    children: /*#__PURE__*/_jsx(Cell, Object.assign({}, rest))
  });
}
Day.displayName = 'Day';